

/**
 * @name ShopPaymentsController
 * @description Controller for shop payments. This field is part of the shop
 * model.
 * @param {Unknown} Shop Shop service
 * @param {Unknown} Session Session service
 */
function ShopPaymentsController(
  Shop,
  Session
) {
  let vm = this;

  vm.$onInit = function() {
    vm.updateShop = updateShop;
  };

  // Get the shop of the logged in operator
  const shop = Session.activeState.association.shop;

  // Get the shop profile
  Shop.get(shop.id).then(function(shop) {
    vm.shop = shop;
  });

  /**
   * @name update_shop
   * @description Function to call the shop service to update the shop
   * @param {object} shop The shop to update
   */
  function updateShop(shop) {
    Shop.update(shop).then(function(updatedShop) {
      vm.shop = updatedShop;
    });
  }
}

angular
.module('inkfinder')
.controller('ShopPaymentsController', ShopPaymentsController);



// WEBPACK FOOTER //
// ./components/shop/payments/shop-payments.controller.js